export default ({ FONT_SIZES, COLORS }) => ({
  content: {
    textAlign: 'center',
    maxWidth: '460px',
    padding: '100px 40px',
    '& > h2': {
      ...FONT_SIZES.HEADING_BIG.STYLE,
      margin: '0 0 14px'
    },
    '& > p': {
      margin: '0 0 28px'
    }
  },
  icon: {
    fontSize: '100px',
    marginBottom: '28px',
    color: COLORS.TEXT.LIGHT_GREY.NORMAL
  }
})
